import { useState } from "react";

const KL_OPTIONS = ["KL1", "KL2", "KL3", "KL4", "KL5"];

const KL_COLORS = {
  KL1: "#ba3b46",
  KL2: "#ba3b46",
  KL3: "#d0c407",
  KL4: "#04aa00",
  KL5: "#04aa00",
};

const KL_TEXT = {
  KL1: "heikko",
  KL2: "välttävä",
  KL3: "tyydyttävä",
  KL4: "hyvä",
  KL5: "erinomainen",
};

export default function KuntoarviolauseBlock({ data, onChange }) {
  const [subject, setSubject] = useState(data?.subject || "");
  const [kl, setKl] = useState(data?.kl || "KL3");

  const commit = (nextSubject, nextKl) => {
    onChange?.({ ...data, subject: nextSubject, kl: nextKl });
  };

  const handleKlChange = (e) => {
    const nextKl = e.target.value;
    setKl(nextKl);
    commit(subject, nextKl);
  };

  const klText = KL_TEXT[kl] || "tyydyttävä";
  const color = KL_COLORS[kl] || "#333";

  return (
    <div className="p-2 border rounded bg-white">
      <div className="d-flex flex-wrap align-items-center gap-2 ms-2">
        <span className="text-nowrap">Kokonaisuutena</span>
        <div style={{ display: "inline-grid", minWidth: 100 }}>
          <span style={{
            visibility: "hidden", whiteSpace: "pre",
            padding: "0.375rem 0.75rem", gridArea: "1/1",
            font: "inherit", border: "1px solid transparent",
          }}>
            {subject || "ulko-ovien"}
          </span>
          <input
            className="form-control"
            style={{ gridArea: "1/1", width: "100%" }}
            value={subject}
            onChange={e => setSubject(e.target.value)}
            onBlur={() => commit(subject, kl)}
            placeholder="ulko-ovien"
          />
        </div>
        <span className="text-nowrap">
          kunto on <em>{klText}</em>.
        </span>
        <select
          className="form-select form-select-sm fw-bold"
          style={{ width: "auto", color }}
          value={kl}
          onChange={handleKlChange}
        >
          {KL_OPTIONS.map(k => (
            <option key={k} value={k} style={{ color: KL_COLORS[k] }}>{k}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
